/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Latest_NewsInputs */



/**
* | output |
* | --- |
* | "Latest news" |
*
* @param {Home_Latest_NewsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_latest_news = /** @type {((inputs?: Home_Latest_NewsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Latest_NewsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("最新动态")
	return /** @type {LocalizedString} */ ("Latest news")
});